import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AuthCallback } from "@/components/AuthCallback";
import { AppShell } from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Volunteers from "@/pages/Volunteers";
import VolunteerDetail from "@/pages/VolunteerDetail";
import Teams from "@/pages/Teams";
import Gifts from "@/pages/Gifts";
import Settings from "@/pages/Settings";
import Assessment from "@/pages/Assessment";
import PublicResult from "@/pages/PublicResult";
import Billing from "@/pages/Billing";
import AdminCodes from "@/pages/AdminCodes";
import SampleResults from "@/pages/SampleResults";
import { PaymentSuccess, PaymentCancel, PaypalReturn } from "@/pages/Payment";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
};

const INDEXABLE = ["/", "/free-assessment", "/sample-results"];

const useRobots = (path) => useEffect(() => {
  const open = INDEXABLE.includes(path);
  document.querySelector('meta[name="robots"]')?.setAttribute("content", open ? "index, follow" : "noindex, nofollow");
  document.querySelector('link[rel="canonical"]')?.setAttribute("href", `https://www.dreamteams.church${open ? path : "/"}`);
}, [path]);

function AppRouter() {
  const location = useLocation();
  useRobots(location.pathname);
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <ScrollTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/c/:slug" element={<Assessment />} />
        <Route path="/free-assessment" element={<Assessment free />} />
        <Route path="/sample-results" element={<SampleResults />} />

        <Route path="/r/:vid" element={<PublicResult />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/payment/paypal-return" element={<PaypalReturn />} />
        <Route element={<AppShell requireChurch={false} />}>
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/admin/codes" element={<AdminCodes />} />
        </Route>
        <Route element={<AppShell />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/volunteers" element={<Volunteers />} />
          <Route path="/volunteers/:vid" element={<VolunteerDetail />} />
          <Route path="/teams" element={<Teams />} />
          <Route path="/gifts" element={<Gifts />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/billing" element={<Billing />} />
        </Route>
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="bottom-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
